import clsx from 'clsx'

export function FireDot({ className = '', fillColor = '#9E9D92' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
      className={clsx(className)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.21841 0.230563C3.00641 0.283579 2.80113 0.353579 2.60411 0.439034C2.86568 0.455534 3.06202 0.37745 3.21841 0.230563ZM0.203857 4.09599C0.203857 2.47021 1.17762 1.07186 2.57373 0.452363C3.18875 0.658606 3.85882 0.56439 4.4241 0.145111C4.35425 0.481748 4.23152 0.791927 4.11025 1.09838C3.90902 1.60693 3.71185 2.10521 3.76722 2.69711C3.99427 2.02594 4.4818 1.51537 5.12174 1.20032C4.32712 2.0793 4.02857 4.01603 4.04718 5.2301C4.05839 4.98534 4.14299 4.77722 4.29114 4.55472C4.67862 3.97865 5.33949 3.66323 5.99436 3.35068C6.47142 3.12298 6.9453 2.89681 7.30798 2.5725C6.77574 3.08044 6.49919 3.71786 6.34843 4.46801C6.5095 4.08786 7.00723 3.76821 7.37395 3.59651C7.61655 3.48214 7.85815 3.39257 8.09613 3.31632C8.14616 3.56846 8.17239 3.82916 8.17239 4.09599C8.17239 6.29644 6.38857 8.08026 4.18812 8.08026C1.98767 8.08026 0.203857 6.29644 0.203857 4.09599ZM3.76911 2.69514L3.76902 2.69869L3.76724 2.69871C3.76729 2.69694 3.76911 2.69514 3.76911 2.69514Z"
        fill={fillColor}
      />
    </svg>
  )
}
